import { render, staticRenderFns } from "./Createcourse.vue?vue&type=template&id=f0ceb32e&scoped=true"
import script from "./Createcourse.vue?vue&type=script&lang=js"
export * from "./Createcourse.vue?vue&type=script&lang=js"
import style0 from "./Createcourse.vue?vue&type=style&index=0&id=f0ceb32e&prod&lang=less&scoped=true"
import style1 from "./Createcourse.vue?vue&type=style&index=1&id=f0ceb32e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ceb32e",
  null
  
)

export default component.exports